export const collectionActions = [
  {
    name: 'saveCollection',
    label: 'Save Data',
    args: [
      {
        name: 'constructor',
        label: 'Constructor',
        type: 'dropdown',
        optionsType: 'collectionConstructorApi',
        options: [],
        value: '',
      },
      {
        name: 'collection',
        label: 'collection',
        type: 'dropdown',
        optionsType: 'collectionConstructorApi',
        options: [],
        value: '',
      },
      {
        name: 'collectionRequest',
        label: 'Request',
        type: 'dropdown',
        optionsType: 'collectionRequestApi',
        options: [],
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message',
        type: 'text',
        value: '',
      },
      {
        name: 'passPreviousActionFormData',
        label: 'Save Form Submission Data In Browser Storage',
        type: 'boolean',
        value: '',
      },
      {
        name: 'formDataSessionKey',
        label: 'Form Data Session Key',
        type: 'text',
        value: '',
      },
      {
        name: 'formDataBrowserStorageLocation',
        label: 'Session Storage Location (Optional)',
        type: 'dropdown',
        optionsType: 'browserStorageLocationOptions',
        options: [],
        value: 'SESSION_STORAGE',
      },
      {
        name: 'passPreviousActionResponse',
        label: 'Save Response Data In Browser Storage',
        type: 'boolean',
        value: '',
      },
      {
        name: 'responseDataSessionKey',
        label: 'Response Data Session Key',
        type: 'text',
        value: '',
      },
      {
        name: 'responseDataSessionStorageLocation',
        label: 'Session Storage Location (Optional)',
        type: 'dropdown',
        optionsType: 'browserStorageLocationOptions',
        options: [],
        value: 'SESSION_STORAGE',
      },
      {
        name: 'enableConsoleLog',
        label: 'Enable Console Logs',
        type: 'boolean',
        value: '',
      },
      {
        name: 'startConsoleLog',
        label: 'Log message on entry',
        type: 'text',
        value: '',
      },
      {
        name: 'endConsoleLog',
        label: 'Log message on exit',
        type: 'text',
        value: '',
      },
    ],
  },
  {
    name: 'updateCollection',
    label: 'Update Data',
    args: [
      {
        name: 'constructor',
        label: 'Constructor',
        type: 'dropdown',
        optionsType: 'collectionConstructorApi',
        options: [],
        value: '',
      },
      {
        name: 'collection',
        label: 'collection',
        type: 'dropdown',
        optionsType: 'collectionConstructorApi',
        options: [],
        value: '',
      },
      {
        name: 'collectionRequest',
        label: 'Select Request Type (Optional)',
        type: 'dropdown',
        optionsType: 'collectionRequestApi',
        options: [],
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message',
        type: 'text',
        value: '',
      },
      {
        name: 'passPreviousActionFormData',
        label: 'Save Form Submission Data In Browser Storage',
        type: 'boolean',
        value: '',
      },
      {
        name: 'formDataSessionKey',
        label: 'Form Data Session Key',
        type: 'text',
        value: '',
      },
      {
        name: 'formDataBrowserStorageLocation',
        label: 'Session Storage Location (Optional)',
        type: 'dropdown',
        optionsType: 'browserStorageLocationOptions',
        options: [],
        value: 'SESSION_STORAGE',
      },
      {
        name: 'passPreviousActionResponse',
        label: 'Save Response Data In Browser Storage',
        type: 'boolean',
        value: '',
      },
      {
        name: 'responseDataSessionKey',
        label: 'Response Data Session Key',
        type: 'text',
        value: '',
      },
      {
        name: 'responseDataSessionStorageLocation',
        label: 'Session Storage Location (Optional)',
        type: 'dropdown',
        optionsType: 'browserStorageLocationOptions',
        options: [],
        value: 'SESSION_STORAGE',
      },
      {
        name: 'enableConsoleLog',
        label: 'Enable Console Logs',
        type: 'boolean',
        value: '',
      },
      {
        name: 'startConsoleLog',
        label: 'Log message on entry',
        type: 'text',
        value: '',
      },
      {
        name: 'endConsoleLog',
        label: 'Log message on exit',
        type: 'text',
        value: '',
      },
    ],
  },
  {
    name: 'saveCollectionDraft',
    label: 'Save Data as Draft',
    args: [
      {
        name: 'constructor',
        label: 'Constructor',
        type: 'dropdown',
        optionsType: 'collectionConstructorApi',
        options: [],
        value: '',
      },
      {
        name: 'collection',
        label: 'collection',
        type: 'dropdown',
        optionsType: 'collectionConstructorApi',
        options: [],
        value: '',
      },
      {
        name: 'collectionRequest',
        label: 'Request',
        type: 'dropdown',
        optionsType: 'collectionRequestApi',
        options: [],
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message',
        type: 'text',
        value: '',
      },
      {
        name: 'passPreviousActionFormData',
        label: 'Save Form Submission Data In Browser Storage',
        type: 'boolean',
        value: '',
      },
      {
        name: 'resetFormData',
        label: 'Reset Form Data On Save',
        type: 'boolean',
        value: '',
      },
      {
        name: 'formDataSessionKey',
        label: 'Form Data Session Key',
        type: 'text',
        value: '',
      },
      {
        name: 'formDataBrowserStorageLocation',
        label: 'Session Storage Location (Optional)',
        type: 'dropdown',
        optionsType: 'browserStorageLocationOptions',
        options: [],
        value: 'SESSION_STORAGE',
      },
      {
        name: 'passPreviousActionResponse',
        label: 'Save Response Data In Browser Storage',
        type: 'boolean',
        value: '',
      },
      {
        name: 'responseDataSessionKey',
        label: 'Response Data Session Key',
        type: 'text',
        value: '',
      },
      {
        name: 'responseDataSessionStorageLocation',
        label: 'Session Storage Location (Optional)',
        type: 'dropdown',
        optionsType: 'browserStorageLocationOptions',
        options: [],
        value: 'SESSION_STORAGE',
      },
      {
        name: 'enableConsoleLog',
        label: 'Enable Console Logs',
        type: 'boolean',
        value: '',
      },
      {
        name: 'startConsoleLog',
        label: 'Log message on entry',
        type: 'text',
        value: '',
      },
      {
        name: 'endConsoleLog',
        label: 'Log message on exit',
        type: 'text',
        value: '',
      },
    ],
  },
  {
    name: 'updateCollectionDraft',
    label: 'Update Data as Draft',
    args: [
      {
        name: 'constructor',
        label: 'Constructor',
        type: 'dropdown',
        optionsType: 'collectionConstructorApi',
        options: [],
        value: '',
      },
      {
        name: 'collection',
        label: 'collection',
        type: 'dropdown',
        optionsType: 'collectionConstructorApi',
        options: [],
        value: '',
      },
      {
        name: 'collectionRequest',
        label: 'Select Request Type (Optional)',
        type: 'dropdown',
        optionsType: 'collectionRequestApi',
        options: [],
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message',
        type: 'text',
        value: '',
      },
      {
        name: 'passPreviousActionFormData',
        label: 'Save Form Submission Data In Browser Storage',
        type: 'boolean',
        value: '',
      },
      {
        name: 'resetFormData',
        label: 'Reset Form Data On Update',
        type: 'boolean',
        value: '',
      },
      {
        name: 'formDataSessionKey',
        label: 'Form Data Session Key',
        type: 'text',
        value: '',
      },
      {
        name: 'formDataBrowserStorageLocation',
        label: 'Session Storage Location (Optional)',
        type: 'dropdown',
        optionsType: 'browserStorageLocationOptions',
        options: [],
        value: 'SESSION_STORAGE',
      },
      {
        name: 'passPreviousActionResponse',
        label: 'Save Response Data In Browser Storage',
        type: 'boolean',
        value: '',
      },
      {
        name: 'responseDataSessionKey',
        label: 'Response Data Session Key',
        type: 'text',
        value: '',
      },
      {
        name: 'responseDataSessionStorageLocation',
        label: 'Session Storage Location (Optional)',
        type: 'dropdown',
        optionsType: 'browserStorageLocationOptions',
        options: [],
        value: 'SESSION_STORAGE',
      },
      {
        name: 'enableConsoleLog',
        label: 'Enable Console Logs',
        type: 'boolean',
        value: '',
      },
      {
        name: 'startConsoleLog',
        label: 'Log message on entry',
        type: 'text',
        value: '',
      },
      {
        name: 'endConsoleLog',
        label: 'Log message on exit',
        type: 'text',
        value: '',
      },
    ],
  },
  {
    name: 'saveCollectionWithReferenceItems',
    label: 'Save Collection + Reference items',
    args: [
      {
        name: 'collection',
        label: 'collection',
        type: 'dropdown',
        optionsType: 'collectionApi',
        options: [],
        value: '',
      },
      {
        name: 'constructor',
        label: 'Constructor',
        type: 'dropdown',
        optionsType: 'collectionConstructorApi',
        options: [],
        value: '',
      },
      {
        name: 'createReferenceFields',
        label: 'Do you want to Create Reference items?',
        type: 'boolean',
        value: '',
      },
      {
        name: 'collectionRefFields',
        label: 'Collection Reference Fields',
        type: 'dropdown',
        optionsType: 'collectionRequestApi',
        options: [],
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message',
        type: 'text',
        value: '',
      },
      {
        name: 'passPreviousActionFormData',
        label: 'Save Form Submission Data In Browser Storage',
        type: 'boolean',
        value: '',
      },
      {
        name: 'formDataSessionKey',
        label: 'Form Data Session Key',
        type: 'text',
        value: '',
      },
      {
        name: 'formDataBrowserStorageLocation',
        label: 'Session Storage Location (Optional)',
        type: 'dropdown',
        optionsType: 'browserStorageLocationOptions',
        options: [],
        value: 'SESSION_STORAGE',
      },
      {
        name: 'passPreviousActionResponse',
        label: 'Save Response Data In Browser Storage',
        type: 'boolean',
        value: '',
      },
      {
        name: 'responseDataSessionKey',
        label: 'Response Data Session Key',
        type: 'text',
        value: '',
      },
      {
        name: 'responseDataSessionStorageLocation',
        label: 'Session Storage Location (Optional)',
        type: 'dropdown',
        optionsType: 'browserStorageLocationOptions',
        options: [],
        value: 'SESSION_STORAGE',
      },
      {
        name: 'saveReferenceItemsToSession',
        label: 'Save Reference Item In Browser Storage',
        type: 'boolean',
        value: '',
      },
      {
        name: 'referenceItemSessionKey',
        label: 'Response Data Session Key',
        type: 'text',
        value: '',
      },
      {
        name: 'referenceItemSessionStorageLocation',
        label: 'Session Storage Location (Optional)',
        type: 'dropdown',
        optionsType: 'browserStorageLocationOptions',
        options: [],
        value: 'SESSION_STORAGE',
      },
      {
        name: 'enableConsoleLog',
        label: 'Enable Console Logs',
        type: 'boolean',
        value: '',
      },
      {
        name: 'startConsoleLog',
        label: 'Log message on entry',
        type: 'text',
        value: '',
      },
      {
        name: 'endConsoleLog',
        label: 'Log message on exit',
        type: 'text',
        value: '',
      },
    ],
  },
  {
    name: 'updateCollectionWithReferenceItems',
    label: 'Update Collection + Reference items',
    args: [
      {
        name: 'collection',
        label: 'collection',
        type: 'dropdown',
        optionsType: 'collectionApi',
        options: [],
        value: '',
      },
      {
        name: 'constructor',
        label: 'Constructor',
        type: 'dropdown',
        optionsType: 'collectionConstructorApi',
        options: [],
        value: '',
      },
      {
        name: 'createReferenceFields',
        label: 'Do you want to Create Reference items?',
        type: 'boolean',
        value: '',
      },
      {
        name: 'collectionRefFields',
        label: 'Collection Reference Fields',
        type: 'dropdown',
        optionsType: 'collectionRequestApi',
        options: [],
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message',
        type: 'text',
        value: '',
      },
      {
        name: 'passPreviousActionFormData',
        label: 'Save Form Submission Data In Browser Storage',
        type: 'boolean',
        value: '',
      },
      {
        name: 'formDataSessionKey',
        label: 'Form Data Session Key',
        type: 'text',
        value: '',
      },
      {
        name: 'formDataBrowserStorageLocation',
        label: 'Session Storage Location (Optional)',
        type: 'dropdown',
        optionsType: 'browserStorageLocationOptions',
        options: [],
        value: 'SESSION_STORAGE',
      },
      {
        name: 'passPreviousActionResponse',
        label: 'Save Response Data In Browser Storage',
        type: 'boolean',
        value: '',
      },
      {
        name: 'responseDataSessionKey',
        label: 'Response Data Session Key',
        type: 'text',
        value: '',
      },
      {
        name: 'responseDataSessionStorageLocation',
        label: 'Session Storage Location (Optional)',
        type: 'dropdown',
        optionsType: 'browserStorageLocationOptions',
        options: [],
        value: 'SESSION_STORAGE',
      },
      {
        name: 'saveReferenceItemsToSession',
        label: 'Save Reference Item In Browser Storage',
        type: 'boolean',
        value: '',
      },
      {
        name: 'referenceItemSessionKey',
        label: 'Response Data Session Key',
        type: 'text',
        value: '',
      },
      {
        name: 'referenceItemSessionStorageLocation',
        label: 'Session Storage Location (Optional)',
        type: 'dropdown',
        optionsType: 'browserStorageLocationOptions',
        options: [],
        value: 'SESSION_STORAGE',
      },
      {
        name: 'enableConsoleLog',
        label: 'Enable Console Logs',
        type: 'boolean',
        value: '',
      },
      {
        name: 'startConsoleLog',
        label: 'Log message on entry',
        type: 'text',
        value: '',
      },
      {
        name: 'endConsoleLog',
        label: 'Log message on exit',
        type: 'text',
        value: '',
      },
    ],
  },
  {
    name: 'bulkUpdateCollection',
    label: 'Bulk Update Data',
    args: [
      {
        name: 'collectionRequest',
        label: 'Select Request Type (Optional)',
        type: 'dropdown',
        optionsType: 'collectionRequestApi',
        options: [],
        value: '',
      },
      {
        name: 'skipEmptyValues',
        label: 'Skip Empty Values (Only updates non-empty fields)',
        type: 'boolean',
        value: '',
        custom: [],
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message',
        type: 'text',
        value: '',
      },
      {
        name: 'passPreviousActionFormData',
        label: 'Save Form Submission Data In Browser Storage',
        type: 'boolean',
        value: '',
      },
      {
        name: 'formDataSessionKey',
        label: 'Form Data Session Key',
        type: 'text',
        value: '',
      },
      {
        name: 'formDataBrowserStorageLocation',
        label: 'Session Storage Location (Optional)',
        type: 'dropdown',
        optionsType: 'browserStorageLocationOptions',
        options: [],
        value: 'SESSION_STORAGE',
      },
      {
        name: 'passPreviousActionResponse',
        label: 'Save Response Data In Browser Storage',
        type: 'boolean',
        value: '',
      },
      {
        name: 'responseDataSessionKey',
        label: 'Response Data Session Key',
        type: 'text',
        value: '',
      },
      {
        name: 'responseDataSessionStorageLocation',
        label: 'Session Storage Location (Optional)',
        type: 'dropdown',
        optionsType: 'browserStorageLocationOptions',
        options: [],
        value: 'SESSION_STORAGE',
      },
    ],
  },
  {
    name: 'updateCollectionOnPageLoad',
    label: 'Update Collection Field',
    args: [
      {
        name: 'collection',
        label: 'Select Collection',
        type: 'dropdown',
        optionsType: 'collectionApi',
        options: [],
        value: '',
      },
      {
        name: 'updateFindBy',
        label: 'Update Collection By',
        type: 'dropdown',
        options: [],
        value: 'byCollectionUuid',
      },
      {
        name: 'updateFindByResponseKeyForValue',
        label: 'Update Collection Find Response Key',
        type: 'text',
        options: [],
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message',
        type: 'text',
        value: '',
      },
    ],
  },
  {
    name: 'deleteCollectionItem',
    label: 'Delete Data',
    args: [
      {
        name: 'collection',
        label: 'Select Collection',
        type: 'dropdown',
        optionsType: 'collectionApi',
        options: [],
        value: '',
      },
      {
        name: 'collectionRequest',
        label: 'Select Request Type (Optional)',
        type: 'dropdown',
        optionsType: 'collectionRequestApi',
        options: [],
        value: '',
      },
      {
        name: 'confirmationMessage',
        label: 'Alert Message',
        type: 'text',
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message',
        type: 'text',
        value: '',
      },
    ],
  },
  {
    name: 'addToCollectionItem',
    label: 'Add Data To Collection Field',
    args: [
      {
        name: 'collectionRequest',
        label: 'Select Request Type (Optional)',
        type: 'dropdown',
        optionsType: 'collectionRequestApi',
        options: [],
        value: '',
      },
    ],
  },
  {
    name: 'removeFromCollectionItem',
    label: 'Remove Data From Collection Field',
    args: [
      {
        name: 'collectionRequest',
        label: 'Select Request Type (Optional)',
        type: 'dropdown',
        optionsType: 'collectionRequestApi',
        options: [],
        value: '',
      },
      {
        name: 'confirmationMessage',
        label: 'Alert Message',
        type: 'text',
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message',
        type: 'text',
        value: '',
      },
    ],
  },
  {
    name: 'dependentDropDownPopulateOnChange',
    label: 'Create Dependent Dropdown',
    args: [
      {
        name: 'collection',
        label: 'Select Collection',
        type: 'dropdown',
        optionsType: 'collectionApi',
        options: [],
        value: '',
      },
      {
        name: 'source',
        label: 'Source',
        type: 'dropdown',
        optionsType: 'sourceApi',
        options: [],
        value: 'PAGE',
      },
      {
        name: 'formPage',
        label: 'Page',
        type: 'dropdown',
        optionsType: 'sourcePageApi',
        options: [],
        value: '',
      },
      {
        name: 'pageComponent',
        label: 'Select Form Component',
        type: 'dropdown',
        optionsType: 'pageFormComponent',
        options: [],
        value: '',
      },
      {
        name: 'onChangeElementName',
        label: 'On Change Element Name',
        type: 'dropdown',
        optionsType: 'pageCollectionFormComponent',
        value: '',
      },
      {
        name: 'valuesToChangeElementName',
        label: 'Values To Change Element Name',
        type: 'dropdown',
        optionsType: 'pageCollectionFormComponent',
        value: '',
      },
      {
        name: 'changeValuesCollection',
        label: 'Change Value Collection',
        type: 'dropdown',
        optionsType: 'collectionApi',
        options: [],
        value: '',
      },
      {
        name: 'field',
        type: 'dropdown',
        optionsType: 'collectionFieldApi',
        options: [],
        value: '',
      },
    ],
  },
  {
    name: 'updateCurrentLoggedInUserData',
    label: 'Update Current Logged In User',
    args: [
      {
        name: 'constructor',
        label: 'Constructor (Optional)',
        type: 'dropdown',
        optionsType: 'collectionConstructorApi',
        options: [],
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message (Optional)',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message (Optional)',
        type: 'text',
        value: '',
      },
    ],
  },
  {
    name: 'removeCollectionFieldData',
    label: 'Remove Collection Field Data',
    args: [
      {
        name: 'collection',
        label: 'Select Collection',
        type: 'dropdown',
        optionsType: 'collectionApi',
        options: [],
        value: '',
      },
      {
        name: 'fields',
        label: 'Select Field(s)',
        type: 'dropdown',
        multi: true,
        optionsType: 'collectionFieldApi',
        options: [],
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message (Optional)',
        type: 'text',
        value: '',
        optional: true,
      },
      {
        name: 'errorMessage',
        label: 'Error Message (Optional)',
        type: 'text',
        value: '',
        optional: true,
      },
    ],
  },
  {
    name: 'saveCollectionAssets',
    label: 'Save Collection Assets',
    args: [
      {
        name: 'collection',
        label: 'Select Collection',
        type: 'dropdown',
        optionsType: 'collectionApi',
        options: [],
        value: '',
      },
      {
        name: 'collectionField',
        label: 'Select Field',
        type: 'dropdown',
        optionsType: 'collectionFieldApi',
        options: [],
        value: '',
      },
      {
        name: 'belongsToField',
        label: 'Select Belongs To Field',
        type: 'dropdown',
        optionsType: 'collectionFieldApi',
        options: [],
        value: '',
      },
      {
        name: 'singleAssets',
        label: 'Save As Single Object',
        type: 'boolean',
        value: '',
        custom: [],
      },
      {
        name: 'successMessage',
        label: 'Success Message (Optional)',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message (Optional)',
        type: 'text',
        value: '',
      },
    ],
  },
  {
    name: 'updateCollectionAssets',
    label: 'Update Collection Assets',
    args: [
      {
        name: 'collection',
        label: 'Select Collection',
        type: 'dropdown',
        optionsType: 'collectionApi',
        options: [],
        value: '',
      },
      {
        name: 'collectionField',
        label: 'Select Field',
        type: 'dropdown',
        optionsType: 'collectionFieldApi',
        options: [],
        value: '',
      },
      {
        name: 'belongsToField',
        label: 'Select Belongs To Field',
        type: 'dropdown',
        optionsType: 'collectionFieldApi',
        options: [],
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message (Optional)',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message (Optional)',
        type: 'text',
        value: '',
      },
    ],
  },
  {
    name: 'pdfToText',
    label: 'PDF to Text',
    args: [
      {
        name: 'collection',
        label: 'Select Collection',
        type: 'dropdown',
        optionsType: 'collectionApi',
        options: [],
        value: '',
      },
      {
        name: 'fieldForPdf',
        type: 'dropdown',
        optionsType: 'collectionFieldApi',
        options: [],
        value: '',
      },
      {
        name: 'fieldForText',
        type: 'dropdown',
        optionsType: 'collectionFieldApi',
        options: [],
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message',
        type: 'text',
        value: '',
      },
      {
        name: 'sendItemIdFrom',
        label: 'Send Item ID From',
        type: 'dropdown',
        optionsType: '',
        options: [],
        value: 'sendCurrentObjectID',
      },
      {
        name: 'bslCollection',
        label: 'Item Collection',
        type: 'dropdown',
        optionsType: 'collectionApi',
        options: [],
        value: '',
      },
      {
        name: 'browserStorageLocation',
        label: 'Session Storage Location (Optional)',
        type: 'dropdown',
        optionsType: 'browserStorageLocationOptions',
        options: [],
        value: 'SESSION_STORAGE',
      },
      {
        name: 'itemIdBSLKey',
        label: 'Item ID JSON Key',
        type: 'text',
        value: '',
      },
    ],
  },
  {
    name: 'anyFileToText',
    label: 'AnyFile to Text',
    args: [
      {
        name: 'collection',
        label: 'Select Collection',
        type: 'dropdown',
        optionsType: 'collectionApi',
        options: [],
        value: '',
      },
      {
        name: 'fieldForPdf',
        type: 'dropdown',
        optionsType: 'collectionFieldApi',
        options: [],
        value: '',
      },
      {
        name: 'fieldForText',
        type: 'dropdown',
        optionsType: 'collectionFieldApi',
        options: [],
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message',
        type: 'text',
        value: '',
      },
      {
        name: 'sendItemIdFrom',
        label: 'Send Item ID From',
        type: 'dropdown',
        optionsType: '',
        options: [],
        value: 'sendCurrentObjectID',
      },
      {
        name: 'bslCollection',
        label: 'Item Collection',
        type: 'dropdown',
        optionsType: 'collectionApi',
        options: [],
        value: '',
      },
      {
        name: 'browserStorageLocation',
        label: 'Session Storage Location (Optional)',
        type: 'dropdown',
        optionsType: 'browserStorageLocationOptions',
        options: [],
        value: 'SESSION_STORAGE',
      },
      {
        name: 'itemIdBSLKey',
        label: 'Item ID JSON Key',
        type: 'text',
        value: '',
      },
    ],
  },
];
